import React from 'react'
import styled from 'styled-components'
import {formatPrice} from '../../utils/format-price'
import { LineItem } from './line-item'
import './cart.css'
import {
 checkoutButton,
} from "./cart.module.css"
import { StoreContext } from "../context/store-context"
const CartCheckout = styled.div`
    background: #e7e7e7;
    width: 100%;
    padding: 1rem;
    bottom:0;
    z-index:100000000;
`
const CartFixed = styled.div`
   
`


const Cart = ({children, isOpen,parentStateSetter}) => {
  const { checkout, loading } = React.useContext(StoreContext)
  const emptyCart = checkout.lineItems.length === 0
  let CartLength = 0
  checkout.lineItems.map((item) => (
   CartLength += item.quantity
  ))
  const [isClicked, setIsClicked] = React.useState();
  const boxRef = React.useRef(null);
  OutsideClick(boxRef); 
  const handleCheckout = () => {
    window.location.assign(checkout.webUrl)
  }
function OutsideClick(ref) {
    React.useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          setIsClicked(true);
          parentStateSetter(isClicked);
          
        } else {
          setIsClicked(false);
        }
      }
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
      return isClicked;
     
    }
  React.useEffect(()=>
  {
if(isOpen)
{
  document.querySelector('body').classList.add('overflow')
}else{
  document.querySelector('body').classList.remove('overflow')

}
  },[isOpen])
  
  return (
    <CartFixed ref={boxRef}  className={isOpen ? "cart-active": "cart"}>
      <div className='flex justify-between p-8 border-b'>
        <h1 className='text-item uppercase'>Your Cart</h1>
        <span className='cart-num'>({CartLength})</span>
        <div className='place-self-center'>
      {children}
    </div>
   
      </div>
      
      {emptyCart ? (
          <div className='flex flex-col w-full text-center'>
           <h2 className='text-p text-center  mt-4'>Your cart is empty</h2>
           <span className='text-smol text-center font-thin'>Find products you'll love</span>
           </div>
        ): 
        
        (
          <>
          <div>

            <div className='p-4'>
                {checkout.lineItems.map((item) => (
                  <LineItem item={item} key={item.id} />
                ))}


              </div>
              <CartCheckout className='sticky '>
<ul className=' font-thin'>
  <li className='flex justify-between py-1 text-p'>
<span>Subtotal</span>
<span className='font-bold'> {formatPrice(
                      checkout.subtotalPriceV2.currencyCode,
                      checkout.subtotalPriceV2.amount
                    )}</span>
  </li>
  <li className='flex justify-between py-1 text-smol'>
<span>Taxes</span>
<span>Calculated at checkout
</span>
  </li>
  <li className='flex justify-between py-1 text-smol'>
<span>Estimated shipping</span>
<span>FREE
</span>
  </li>
  <p className='text-smol italic'>*New and/or refurbished products may process and ship at different times.</p>
  <button
              onClick={handleCheckout}
              disabled={loading}
              className={checkoutButton}
            >
              Proceed to Checkout
            </button>
</ul>
                </CartCheckout>
            </div>
          </>
        )
        }
          
    </CartFixed>
  )
}

export default Cart